import {
  forEach, get, includes, isEmpty, map, values,
} from 'lodash';
import firebase from '@/services/firebase';
import React, {
  useContext, useEffect, useMemo, useState,
} from 'react';
import { Redirect, useParams } from 'react-router-dom';
import MenuCampaignsCmp from '../components/MenuCampaigns';
import menuContext from '../contexts/menu';

export default function MenuCampaigns() {
  const [fridgeCampaigns, setFridgeCampaigns] = useState([]);
  const { fridgeId: selectedFridgeId } = useParams() || {};
  const { menuCache } = useContext(menuContext);
  const { products, fridges: fridgeDict } = menuCache || {};

  useEffect(() => {
    const dataRef = firebase.database().ref(`/${process.env.REACT_APP_MODE}/menu/currentCheckoutCampaign/${selectedFridgeId}`);

    dataRef.on('value', (snapshot) => {
      setFridgeCampaigns(snapshot.val() || []);
    });

    return () => {
      dataRef.off('value');
    };
  }, [selectedFridgeId]);

  const data = useMemo(() => map(fridgeCampaigns, (campaign) => {
    const { template, campaignImageUrl } = campaign;
    const productIds = get(campaign, ['templateData', 'productIds'], []);
    const productDict = {};

    if (includes(['E002', 'E004', 'E005'], template)) {
      forEach(productIds, (productId) => {
        const product = get(products, [productId], null);

        if (isEmpty(product)) return;

        productDict[productId] = {
          ...product,
          id: productId,
        };
      });
    } else {
      forEach(get(campaign, ['productIds'], []), (productId) => {
        const product = get(products, [productId], null);

        if (isEmpty(product)) return;

        productDict[productId] = {
          ...product,
          id: productId,
        };
      });
    }

    return {
      ...campaign,
      coverImage: campaignImageUrl,
      fridgeName: get(fridgeDict, [selectedFridgeId, 'name'], ''),
      products: values(productDict),
    };
  }), [fridgeCampaigns, products, fridgeDict, selectedFridgeId]);

  return isEmpty(selectedFridgeId) ? (
    <Redirect to="/" replace />
  ) : (
    <MenuCampaignsCmp data={data} />
  );
}
